import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, AlertCircle, Loader2, ArrowRight } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function LeadConfirm() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [state, setState] = useState({ status: "loading", message: "" });

    useEffect(() => {
        if (!token) {
            setState({ status: "error", message: "Kein Bestätigungstoken gefunden." });
            return;
        }
        api.post("/leads/confirm", { token })
            .then((r) => {
                if (r.data.already_confirmed) {
                    setState({ status: "success", message: "Diese Anfrage wurde bereits bestätigt. Das PDF wurde Ihnen zugesendet." });
                } else if (r.data.email_status === "sent") {
                    setState({ status: "success", message: "Vielen Dank! Das PDF ist auf dem Weg zu Ihnen." });
                } else if (r.data.email_status === "no_pdf") {
                    setState({ status: "warning", message: "Bestätigung erfolgt — wir senden Ihnen das PDF, sobald es bereitsteht." });
                } else {
                    setState({ status: "warning", message: "Bestätigung erfolgreich. Versand verzögert — wir kümmern uns." });
                }
            })
            .catch((err) => {
                setState({
                    status: "error",
                    message: formatApiError(err.response?.data?.detail) || "Bestätigung fehlgeschlagen.",
                });
            });
    }, [token]);

    const Icon = {
        loading: Loader2,
        success: CheckCircle2,
        warning: CheckCircle2,
        error: AlertCircle,
    }[state.status];

    const tone = {
        loading: "bg-aimploy-violet/10 text-aimploy-violet",
        success: "bg-emerald-50 text-emerald-700",
        warning: "bg-amber-50 text-amber-700",
        error: "bg-red-50 text-red-700",
    }[state.status];

    return (
        <div className="min-h-[70vh] flex items-center justify-center p-6" data-testid="lead-confirm-page">
            <div className="max-w-lg w-full bg-white rounded-3xl p-10 lg:p-12 border border-black/5 text-center">
                <div className={`mx-auto h-16 w-16 rounded-full ${tone} flex items-center justify-center mb-6`}>
                    <Icon className={`w-7 h-7 ${state.status === "loading" ? "animate-spin" : ""}`} />
                </div>
                <h1 className="font-display text-3xl lg:text-4xl font-bold mb-4">
                    {state.status === "loading" && "Bestätige Ihre Anfrage…"}
                    {state.status === "success" && "Bestätigt!"}
                    {state.status === "warning" && "Fast geschafft"}
                    {state.status === "error" && "Hm, das hat nicht geklappt"}
                </h1>
                <p className="text-aimploy-muted mb-8" data-testid="lead-confirm-message">{state.message}</p>
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 bg-aimploy-navy hover:bg-aimploy-navy-hover text-white px-6 py-3 rounded-full text-sm font-semibold transition-colors"
                >
                    Zurück zur Startseite <ArrowRight className="w-4 h-4" />
                </Link>
            </div>
        </div>
    );
}
